import { useCallback, useContext } from "react";
import { TextInput } from "@mantine/core";
import { EditableInfoRowContext } from "./EditableInfoRowContext";
import type { SaveRequisitionFields } from "./DocumentHeaderTypes";

interface MrnEditorProps {
  mrn: string;
  savePatient: SaveRequisitionFields;
}

export function MrnEditor({ mrn, savePatient }: MrnEditorProps) {
  const setOverride = useContext(EditableInfoRowContext);
  const handleBlur = useCallback(
    (event: React.FocusEvent<HTMLInputElement>) => {
      setOverride?.(event.target.value || "—");
      savePatient({ medicalRecordNumber: event.target.value });
    },
    [savePatient, setOverride]
  );

  return (
    <TextInput
      size="xs"
      defaultValue={mrn}
      placeholder="MRN"
      onBlur={handleBlur}
      style={{ width: 160 }}
    />
  );
}
